export default __webpack_public_path__ + "static/media/portraitMedium.91494877.jpg";